let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c6zAX")).then(() => parcelRequire('7DqLt'));